import React from 'react';
import { ShieldCheck, Lock, CreditCard, Headphones, Sparkles, CheckCircle } from 'lucide-react';

interface WhyChooseSectionProps {
  onOpenSafety?: () => void;
}

export const WhyChooseSection: React.FC<WhyChooseSectionProps> = ({ onOpenSafety }) => {
  const features = [
    {
      id: 'verified',
      icon: ShieldCheck,
      title: 'Verified Profiles',
      description: 'All profiles are manually verified',
      iconBg: 'bg-purple-100 text-purple-600',
    },
    {
      id: 'privacy',
      icon: Lock,
      title: 'Privacy First',
      description: 'Your privacy and safety is our priority',
      iconBg: 'bg-pink-100 text-pink-600',
    },
    {
      id: 'payment',
      icon: CreditCard,
      title: 'Secure Payment',
      description: '100% secure payment gateway',
      iconBg: 'bg-violet-100 text-violet-600',
    },
    {
      id: 'support',
      icon: Headphones,
      title: '24/7 Support',
      description: "We're here to help you anytime",
      iconBg: 'bg-indigo-100 text-indigo-600',
    },
  ];

  return (
    <section id="why-choose-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {/* Left Title matching screenshot */}
          <div className="lg:col-span-4 space-y-2">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight">
              Why Choose
              <br />
              <span className="text-slate-900">PairUp</span>
              <span className="text-pink-600">Today</span>?
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed max-w-sm pt-2">
              India's premier companion platform crafted with uncompromising standards of safety, privacy, and etiquette.
            </p>
          </div>

          {/* Right 4 Grid Cards matching screenshot */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
            {features.map((feat) => {
              const Icon = feat.icon;
              return (
                <div
                  key={feat.id}
                  id={`why-choose-${feat.id}`}
                  onClick={onOpenSafety}
                  className="bg-white hover:bg-pink-50/40 p-5 rounded-2xl border border-slate-100 hover:border-pink-200 transition-all duration-300 shadow-xs hover:shadow-md flex flex-col items-start cursor-pointer group"
                >
                  <div className={`w-12 h-12 rounded-2xl ${feat.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm group-hover:text-pink-600 transition-colors">
                    {feat.title}
                  </h3>
                  <p className="mt-1 text-xs text-slate-500 leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
};
